<div>
  <form #payTransactionsForm="ngForm" novalidate>
    <div class="modal-header">
      <h4 class="modal-title">Pay Transactions</h4>
      <button type="button" class="btn-close" aria-hidden="true" (click)="cancel()"></button>
    </div>
    <div class="modal-body">
      <div id="rateValidation"
           [ngStyle]="!isAftraRateValid?{'color':'red','font-weight':'bold'}:''">
        <div *ngIf="listItem.aftraAmount"
             class="col-md-12 ps-3">
          AFTRA $:{{listItem.aftraAmount}}
        </div>
        <div *ngIf="!listItem.aftraAmount"
             class="col-md-12 ps-3">
          Rate (DAY):{{listItem.customRate}}
        </div>
      </div>
      <div *ngFor="let transaction of listItemClone.payTransactions; let $index=index;">

        <div>

          <div class="col-md-12 form-group-wrapper form-group d-flex">
            <div class="col-md-4 pe-3 ps-3" [class.has-error]="(!transaction.transactionType?.id && payTransactionsForm.submitted) || null">
              <nbc-form-select [source]="allTransactionTypes"
                               [model]="transaction.selectedTransactionType"
                               (modelChange)="setCode($event,$index)"
                               [nbcRequired]="true"
                               display="description"
                               value="description"
                               name="transactionTypes_{{$index}}"
                               [nbcMismatch]="form-select"
                               placeHolderValue="-1"
                               placeHolderDisplay="Select Pay Transaction">
              </nbc-form-select>
            </div>
            <div class="col-md-2 pe-3 ps-3" [class.has-error]="(!payTransactionsForm.controls.hrUnit_$index?.errors && payTransactionsForm.submitted) || null">
              <input name="hrUnit_{{$index}}"
                     required
                     type="text"
                     class="form-control"
                     [(ngModel)]="transaction.hrUnit"
                     appInputRestriction="numberOnly"
                     placeholder="Hr/Unit" />
            </div>
            <div class="col-md-2 pe-3 ps-3" [class.has-error]="(!payTransactionsForm.controls.rate_$index?.errors && payTransactionsForm.submitted) || null">
              <input name="rate_{{$index}}"
                     required
                     type="text"
                     class="form-control"
                     [(ngModel)]="transaction.rate"
                     placeholder="Rate"
                     nbc-decimal
                     decimals="5"
                     (blur)="checkPayTransactionRate(transaction.rate)" />
            </div>

            <div class="col-md-3 pe-3 ps-3">
              <textarea class="form-control"
                        name="transactionComment_{{$index}}"
                        appInputRestriction="noSpecialChars"
                        maxlength="50"
                        style="resize:none"
                        placeholder="Transaction Comment"
                        [(ngModel)]="transaction.transactionComment">    
            </textarea>
            </div>
            <div class="col-md-1 pe-3 ps-3">
              <a (click)="remove($index)" class="btn btn-icon-clear">
                <i class="fa fa-times-circle"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
      <a class="btn-link" (click)="add()"><i class="fa fa-plus-square"></i> Add another Transaction</a>
    </div>
    <div class="modal-footer text-right">
      <button class="btn btn-default" type="button" (click)="cancel()">Cancel</button>
      <button id="addEntry"
              [attr.disabled]="!isRateValid || null"
              class="btn btn-primary" type="submit" (click)="addPayTransaction(payTransactionsForm)">Add Entry</button>
    </div>
  </form>
</div>
